module.exports = __webpack_public_path__ + "img/temperatureOccurrence.3255b87c.png";